import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, NavigationStart, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import moment from 'moment';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';
import { UsersService } from '../../services/users.service';
import { LoginService } from '../../services/login.service';
import { MFAService } from '../../services/mfa.service';
import { SettingsService } from '../../services/settings.service';
import { CommonService } from '../../services/common.service';
import { HeaderComponent } from '../header/header.component';
import { ModuleService } from '../../services/module.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, HeaderComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private routerSub?: Subscription;
  private cacheChecked = false;
  private copyrightLoading = false;

  inputType = 'password';
  updateBtnText = 'Update';
  resetBtnText = 'Reset Secondary Password';
  updateBtnError = false;
  isUpdateSuccess = false;
  isPasswordValid = true;
  isBtnEnabled = true;

  todayDate = new Date().toISOString().split('T')[0];


  // Add these with your other class variables
  sessionStats: any = null;
  groupedSessionStats: any[] = [];
  selectedUserStatsName: string = '';
  sessionStatsSearch: string = '';
  sessionStatsStartDate: string = '';
  sessionStatsEndDate: string = '';
  appliedStartDate: string = '';
  appliedEndDate: string = '';
  selectedUserActiveSessions: any[] = [];
  isSessionStatsLoading = false;
  showSessionStatsModal = false;
  showUserMessage: string = '';
  sessionStatsFilterMessage: string | null = null;
  private filterMessageTimeout: any;

  // Dashboard Security Settings
  isMFAExpanded = false;
  isResetPasswordExpanded = false;
  isSecurityPrimeUsersExpanded = false;
  isSecurityPasswordPolicyExpanded = false;
  isLoaded = false;
  sortType = 'name';
  search = '';
  activeFilter = 'All';
  activeTab: 'resources' | 'activity' | 'security' = 'resources';

  // KPI Mock Data
  totalUsersCount = '';
  activeSessionsCount = 0;
  rolesCount = 12;
  groupsCount = 8;
  securityHealth = '98%';

  storeManager: any;
  showSuccessCachePopup = false;
  showCacheClearPopup = false;
  showCookieConsentPopup = false;
  cookiesAllowed: string | null = null;
  currentVersion = 'v1r122m0';
  latestVersion: string = '';
  newVersion: string = '';
  allLocationsList: any[] = [];

  activeUsers: any[] = [];
  passwordTerms: any = {};
  hasTerms = false;
  isMfaVerified = false;
  private activeUsersLoading = false;

  head: any = {};
  totalUsersLoading = false;
  passwordHead: any = {};
  secondaryPasswordHead: any = {};
  resetSecondaryPassword = false;
  showPassRstDetails = false;
  showTerms = false;
  panelErrorMessage: string | null = null;

  message: string = '';
  error: string = '';
  copyrightDetails: any;
  deviceThatUses: string = '';
  ipadContent: string = '';

  // Use these booleans in your HTML with [ngClass] or *ngIf instead of jQuery
  passwordValidationState = {
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
    minLength: false
  };
  displayName: any;
  // messages used in template
  activeUsersMessage: string | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr: ChangeDetectorRef,
    private authService: AuthorizationService,
    private usersService: UsersService,
    private loginService: LoginService,
    private mfaService: MFAService,
    private settingsService: SettingsService,
    private common: CommonService,
    private moduleService: ModuleService,
    private router: Router,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {

    this.loadAllLocations();

    // this.fetchSessionStats(); // Now called on user click

    this.getUserdetails();
    this.storeManager = JSON.parse(this.common.SessionMemory.API.Get('store_manager') || '{}');
    this.cookiesAllowed = this.common.LocalMemory.API.Get('cookiesAllowed') || null;

    this.checkCookieConsentInitial();

    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(() => {
      this.checkCookieConsent();
    });

    this.search = '';
    if (isPlatformBrowser(this.platformId)) {

      this.getPasswordPolicy();
      this.getActiveUsers(true);
      this.findByCopyright();
      this.checkCookieConsent();
    }
    this.resetAtMidnight();
    // this.checkPreviousCache();
  }

  loadAllLocations(): Promise<any> {
    if (!this.allLocationsList || this.allLocationsList.length === 0) {
      return this.usersService.GetLocations().then(locs => {
        this.allLocationsList = locs || [];
        this.cdr.detectChanges();
        return this.allLocationsList;
      });
    }
    return Promise.resolve(this.allLocationsList);
  }


  fetchSessionStats(userId?: number, userName?: string, activeSessions?: any[]): void {
    this.isSessionStatsLoading = true;
    this.showSessionStatsModal = true; // Open modal immediately to show loading state
    this.sessionStats = null;
    this.groupedSessionStats = [];
    this.sessionStatsSearch = ''; // Reset filter on new open
    this.sessionStatsStartDate = '';
    this.sessionStatsEndDate = '';
    this.appliedStartDate = '';
    this.appliedEndDate = '';
    this.selectedUserStatsName = userName || '';
    this.selectedUserActiveSessions = activeSessions || [];
    this.sessionStatsFilterMessage = null;

    /*     this.usersService.getSessionStats().subscribe({
          next: (stats: any) => {
            this.loadAllLocations().then(() => {
              this.sessionStats = stats;
    
             // console.log(this.sessionStats);
    
              let statsData = stats.data || stats;
              if (Array.isArray(statsData)) {
                if (userId) {
                  statsData = statsData.filter((s: any) => s.user_id === Number(userId));
                }
    
                // Map location_number to location name
                statsData.forEach((s: any) => {
                  const locNum = s.location_number;
                  if (locNum !== undefined && locNum !== null && locNum !== '') {
                    const loc = this.allLocationsList.find((l: any) => {
                      const lId = l.base_location_id !== undefined && l.base_location_id !== null ? l.base_location_id :
                        (l.location_id !== undefined && l.location_id !== null ? l.location_id : l.id);
                      if (lId === undefined || lId === null) return false;
    
                      // 1. Exact match
                      if (lId === locNum) return true;
    
                      // 2. String comparison (trimmed, case-insensitive)
                      const lIdStr = String(lId).trim().toLowerCase();
                      const locNumStr = String(locNum).trim().toLowerCase();
                      if (lIdStr === locNumStr) return true;
    
                      // 3. Numeric comparison (e.g. 5 vs '05')
                      const lIdNum = Number(lId);
                      const locNumVal = Number(locNum);
                      if (!isNaN(lIdNum) && !isNaN(locNumVal) && lIdNum === locNumVal) return true;
    
                      return false;
                    });
                    s.location_name = loc ? (loc.base_location || loc.name || locNum) : 'Unknown Location';
                  } else {
                    s.location_name = 'Unknown Location';
                  }
                });
    
                const grouped = statsData.reduce((acc: any, curr: any) => {
                  const dateObj = new Date(curr.created_at);
                  const dayTimestamp = !isNaN(dateObj.getTime())
                    ? new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()).getTime()
                    : 0;
    
                  const dateStr = !isNaN(dateObj.getTime())
                    ? dateObj.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })
                    : 'Unknown Date';
    
                  if (!acc[dayTimestamp]) {
                    acc[dayTimestamp] = {
                      date: dateStr,
                      timestamp: dayTimestamp,
                      total_sessions: 0,
                      active_seconds: 0,
                      total_duration_seconds: 0,
                      clicks: 0,
                      keystrokes: 0,
                      scrolls: 0,
                      screen_changes: 0,
                      applications: new Set(),
                      ips: new Set(),
                      sessions: [],
                      applicationsData: {}
                    };
                  }
    
                  acc[dayTimestamp].total_sessions += 1;
                  acc[dayTimestamp].active_seconds += (Number(curr.active_seconds) || 0);
                  acc[dayTimestamp].total_duration_seconds += this.parseDurationToSeconds(curr.session_duration);
                  acc[dayTimestamp].clicks += (Number(curr.clicks) || 0);
                  acc[dayTimestamp].keystrokes += (Number(curr.keystrokes) || 0);
                  acc[dayTimestamp].scrolls += (Number(curr.scrolls) || 0);
                  acc[dayTimestamp].screen_changes += (Number(curr.screen_changes) || 0);
    
                  if (curr.application_name && curr.application_name !== 'null') acc[dayTimestamp].applications.add(curr.application_name);
                  if (curr.local_ip_address && curr.local_ip_address !== 'null') acc[dayTimestamp].ips.add(curr.local_ip_address);
    
                  acc[dayTimestamp].sessions.push(curr);
    
                  // Group by application inside the day group
                  const appName = curr.application_name || 'Unknown Application';
                  if (!acc[dayTimestamp].applicationsData[appName]) {
                    acc[dayTimestamp].applicationsData[appName] = {
                      application_name: appName,
                      total_sessions: 0,
                      active_seconds: 0,
                      total_duration_seconds: 0,
                      clicks: 0,
                      keystrokes: 0,
                      scrolls: 0,
                      screen_changes: 0,
                      ips: new Set(),
                      sessions: []
                    };
                  }
    
                  const appGroup = acc[dayTimestamp].applicationsData[appName];
                  appGroup.total_sessions += 1;
                  appGroup.active_seconds += (Number(curr.active_seconds) || 0);
                  appGroup.total_duration_seconds += this.parseDurationToSeconds(curr.session_duration);
                  appGroup.clicks += (Number(curr.clicks) || 0);
                  appGroup.keystrokes += (Number(curr.keystrokes) || 0);
                  appGroup.scrolls += (Number(curr.scrolls) || 0);
                  appGroup.screen_changes += (Number(curr.screen_changes) || 0);
                  if (curr.local_ip_address && curr.local_ip_address !== 'null') appGroup.ips.add(curr.local_ip_address);
                  appGroup.sessions.push(curr);
    
                  return acc;
                }, {});
    
                // Inject the last 7 days if they don't exist
                const today = new Date();
                for (let i = 0; i < 7; i++) {
                  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i);
                  const ts = d.getTime();
                  if (!grouped[ts]) {
                    grouped[ts] = {
                      date: d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }),
                      timestamp: ts,
                      total_sessions: 0,
                      active_seconds: 0,
                      total_duration_seconds: 0,
                      clicks: 0,
                      keystrokes: 0,
                      scrolls: 0,
                      screen_changes: 0,
                      applications: new Set(),
                      ips: new Set(),
                      sessions: [],
                      applicationsData: {}
                    };
                  }
                }
    
                this.groupedSessionStats = Object.values(grouped).map((group: any) => {
                  group.applications = Array.from(group.applications).filter(Boolean).join(', ');
                  group.ips = Array.from(group.ips).filter(Boolean).join(', ');
                  group.formatted_active_time = this.formatDuration(group.active_seconds);
                  group.formatted_total_duration = this.formatDuration(group.total_duration_seconds);
                  group.expanded = false; // Initialize accordion state
    
                  // Sort sessions within the day group to show the most recent ones first
                  group.sessions.sort((a: any, b: any) => {
                    if (a.id && b.id) {
                      return Number(b.id) - Number(a.id); // Use DB ID to guarantee accurate latest-first insertion order
                    }
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                  });
    
                  // Convert applicationsData map to sorted list
                  if (group.applicationsData) {
                    group.applicationsList = Object.values(group.applicationsData).map((appGroup: any) => {
                      appGroup.ips = Array.from(appGroup.ips).filter(Boolean).join(', ');
                      appGroup.formatted_active_time = this.formatDuration(appGroup.active_seconds);
                      appGroup.formatted_total_duration = this.formatDuration(appGroup.total_duration_seconds);
    
                      appGroup.sessions.sort((a: any, b: any) => {
                        if (a.id && b.id) {
                          return Number(b.id) - Number(a.id);
                        }
                        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                      });
    
                      return appGroup;
                    });
    
                    // Sort applications by session count descending
                    group.applicationsList.sort((a: any, b: any) => b.total_sessions - a.total_sessions);
    
                    // Set default selected application tab
                    group.selectedApp = this.getSelectedAppDefault(group.applicationsList);
                  } else {
                    group.applicationsList = [];
                    group.selectedApp = '';
                  }
    
                  if (group.applicationsList && group.applicationsList.length > 1) {
                    group.header_duration_string = group.applicationsList
                      .map((app: any) => `${app.application_name}: ${app.formatted_total_duration}`)
                      .join(' • ');
                  } else {
                    group.header_duration_string = `Total Time: ${group.formatted_total_duration}`;
                  }
    
                  return group;
                }).sort((a: any, b: any) => b.timestamp - a.timestamp);
    
                const firstWithActivity = this.groupedSessionStats.find((s: any) => s.total_sessions > 0);
                if (firstWithActivity) {
                  firstWithActivity.expanded = true;
                }
              }
    
              this.isSessionStatsLoading = false;
              this.cdr.detectChanges();
            });
          },
          error: (err: any) => {
            console.error('Error fetching session stats:', err);
            this.isSessionStatsLoading = false;
            this.showUserMessage = 'Failed to load session statistics';
            this.cdr.detectChanges();
          }
        }); */
    this.usersService.getSessionStats().subscribe({
      next: (stats: any) => {
        this.loadAllLocations().then(() => {
          this.sessionStats = stats;
          let statsData = stats.data || stats;
          if (Array.isArray(statsData)) {
            if (userId) {
              statsData = statsData.filter((s: any) => s.user_id === Number(userId));
            }

            // --- MINIMAL CHANGE 1: Create a fast Map lookup object ---
            const locationMap = new Map();
            this.allLocationsList.forEach((l: any) => {
              const lId = l.base_location_id ?? l.location_id ?? l.id;
              if (lId !== undefined && lId !== null) {
                locationMap.set(String(lId).trim().toLowerCase(), l);
              }
            });

            // Map location_number to location name
            statsData.forEach((s: any) => {
              const locNum = s.location_number;
              if (locNum !== undefined && locNum !== null && locNum !== '') {

                // --- MINIMAL CHANGE 2: O(1) Fast lookup instead of .find() loop ---
                const searchKey = String(locNum).trim().toLowerCase();
                const loc = locationMap.get(searchKey);

                s.location_name = loc ? (loc.base_location || loc.name || locNum) : 'Unknown Location';
              } else {
                s.location_name = 'Unknown Location';
              }
            });

            const grouped = statsData.reduce((acc: any, curr: any) => {
              const dateObj = new Date(curr.created_at);
              const dayTimestamp = !isNaN(dateObj.getTime())
                ? new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()).getTime()
                : 0;

              const dateStr = !isNaN(dateObj.getTime())
                ? dateObj.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })
                : 'Unknown Date';

              if (!acc[dayTimestamp]) {
                acc[dayTimestamp] = {
                  date: dateStr,
                  timestamp: dayTimestamp,
                  total_sessions: 0,
                  active_seconds: 0,
                  total_duration_seconds: 0,
                  clicks: 0,
                  keystrokes: 0,
                  scrolls: 0,
                  screen_changes: 0,
                  applications: new Set(),
                  ips: new Set(),
                  sessions: [],
                  applicationsData: {}
                };
              }

              acc[dayTimestamp].total_sessions += 1;
              acc[dayTimestamp].active_seconds += (Number(curr.active_seconds) || 0);
              acc[dayTimestamp].total_duration_seconds += this.parseDurationToSeconds(curr.session_duration);
              acc[dayTimestamp].clicks += (Number(curr.clicks) || 0);
              acc[dayTimestamp].keystrokes += (Number(curr.keystrokes) || 0);
              acc[dayTimestamp].scrolls += (Number(curr.scrolls) || 0);
              acc[dayTimestamp].screen_changes += (Number(curr.screen_changes) || 0);

              if (curr.application_name && curr.application_name !== 'null') acc[dayTimestamp].applications.add(curr.application_name);
              if (curr.local_ip_address && curr.local_ip_address !== 'null') acc[dayTimestamp].ips.add(curr.local_ip_address);

              acc[dayTimestamp].sessions.push(curr);

              // Group by application inside the day group
              const appName = curr.application_name || 'Unknown Application';
              if (!acc[dayTimestamp].applicationsData[appName]) {
                acc[dayTimestamp].applicationsData[appName] = {
                  application_name: appName,
                  total_sessions: 0,
                  active_seconds: 0,
                  total_duration_seconds: 0,
                  clicks: 0,
                  keystrokes: 0,
                  scrolls: 0,
                  screen_changes: 0,
                  ips: new Set(),
                  sessions: []
                };
              }

              const appGroup = acc[dayTimestamp].applicationsData[appName];
              appGroup.total_sessions += 1;
              appGroup.active_seconds += (Number(curr.active_seconds) || 0);
              appGroup.total_duration_seconds += this.parseDurationToSeconds(curr.session_duration);
              appGroup.clicks += (Number(curr.clicks) || 0);
              appGroup.keystrokes += (Number(curr.keystrokes) || 0);
              appGroup.scrolls += (Number(curr.scrolls) || 0);
              appGroup.screen_changes += (Number(curr.screen_changes) || 0);
              if (curr.local_ip_address && curr.local_ip_address !== 'null') appGroup.ips.add(curr.local_ip_address);
              appGroup.sessions.push(curr);

              return acc;
            }, {});

            // Inject the last 7 days if they don't exist
            const today = new Date();
            for (let i = 0; i < 7; i++) {
              const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i);
              const ts = d.getTime();
              if (!grouped[ts]) {
                grouped[ts] = {
                  date: d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }),
                  timestamp: ts,
                  total_sessions: 0,
                  active_seconds: 0,
                  total_duration_seconds: 0,
                  clicks: 0,
                  keystrokes: 0,
                  scrolls: 0,
                  screen_changes: 0,
                  applications: new Set(),
                  ips: new Set(),
                  sessions: [],
                  applicationsData: {}
                };
              }
            }

            this.groupedSessionStats = Object.values(grouped).map((group: any) => {
              group.applications = Array.from(group.applications).filter(Boolean).join(', ');
              group.ips = Array.from(group.ips).filter(Boolean).join(', ');
              group.formatted_active_time = this.formatDuration(group.active_seconds);
              group.formatted_total_duration = this.formatDuration(group.total_duration_seconds);
              group.expanded = false; // Initialize accordion state

              // Sort sessions within the day group to show the most recent ones first
              group.sessions.sort((a: any, b: any) => {
                if (a.id && b.id) {
                  return Number(b.id) - Number(a.id); // Use DB ID to guarantee accurate latest-first insertion order
                }
                return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
              });

              // Convert applicationsData map to sorted list
              if (group.applicationsData) {
                group.applicationsList = Object.values(group.applicationsData).map((appGroup: any) => {
                  appGroup.ips = Array.from(appGroup.ips).filter(Boolean).join(', ');
                  appGroup.formatted_active_time = this.formatDuration(appGroup.active_seconds);
                  appGroup.formatted_total_duration = this.formatDuration(appGroup.total_duration_seconds);

                  appGroup.sessions.sort((a: any, b: any) => {
                    if (a.id && b.id) {
                      return Number(b.id) - Number(a.id);
                    }
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                  });

                  return appGroup;
                });

                // --- MINIMAL CHANGE 3: Enforce Prime Application first, then Product Explorer ---
                group.applicationsList.sort((a: any, b: any) => {
                  if (a.application_name === 'Prime Application') return -1;
                  if (b.application_name === 'Prime Application') return 1;
                  if (a.application_name === 'Product Explorer') return -1;
                  if (b.application_name === 'Product Explorer') return 1;
                  return b.total_sessions - a.total_sessions;
                });

                // Set default selected application tab
                group.selectedApp = this.getSelectedAppDefault(group.applicationsList);
              } else {
                group.applicationsList = [];
                group.selectedApp = '';
              }

              if (group.applicationsList && group.applicationsList.length > 1) {
                group.header_duration_string = group.applicationsList
                  .map((app: any) => `${app.application_name}: ${app.formatted_total_duration}`)
                  .join(' • ');
              } else {
                group.header_duration_string = `Total Time: ${group.formatted_total_duration}`;
              }

              return group;
            }).sort((a: any, b: any) => b.timestamp - a.timestamp);

            const firstWithActivity = this.groupedSessionStats.find((s: any) => s.total_sessions > 0);
            if (firstWithActivity) {
              firstWithActivity.expanded = true;
            }
          }

          this.isSessionStatsLoading = false;
          this.cdr.detectChanges();
        });
      },
      error: (err: any) => {
        console.error('Error fetching session stats:', err);
        this.isSessionStatsLoading = false;
        this.showUserMessage = 'Failed to load session statistics';
        this.cdr.detectChanges();
      }
    });

  }

  parseDurationToSeconds(duration: string): number {
    if (!duration) return 0;
    if (!isNaN(Number(duration))) return Number(duration);

    let seconds = 0;

    if (duration.includes(':')) {
      const parts = duration.split(':').map(p => parseInt(p, 10) || 0);
      if (parts.length === 3) {
        seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
      } else if (parts.length === 2) {
        seconds = parts[0] * 60 + parts[1];
      }
      return seconds;
    }

    const hMatch = duration.match(/(\d+)\s*h/i);
    const mMatch = duration.match(/(\d+)\s*m/i);
    const sMatch = duration.match(/(\d+)\s*s/i);

    if (hMatch || mMatch || sMatch) {
      if (hMatch) seconds += parseInt(hMatch[1], 10) * 3600;
      if (mMatch) seconds += parseInt(mMatch[1], 10) * 60;
      if (sMatch) seconds += parseInt(sMatch[1], 10);
      return seconds;
    }

    return 0;
  }

  formatDuration(seconds: number): string {
    if (!seconds || isNaN(seconds)) return '0s';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    if (h > 0) return `${h}h ${m}m ${s}s`;
    if (m > 0) return `${m}m ${s}s`;
    return `${s}s`;
  }

  getSelectedAppDefault(applicationsList: any[]): string {
    if (!applicationsList || applicationsList.length === 0) return '';
    const hasPrime = applicationsList.some(app => app.application_name === 'Prime Application');
    return hasPrime ? 'Prime Application' : applicationsList[0].application_name;
  }

  applyFilters(): void {
    this.appliedStartDate = this.sessionStatsStartDate;
    this.appliedEndDate = this.sessionStatsEndDate;
    this.showFilterMessage('Filter applied successfully.');
  }

  clearFilters(): void {
    this.sessionStatsStartDate = '';
    this.sessionStatsEndDate = '';
    this.appliedStartDate = '';
    this.appliedEndDate = '';
    this.sessionStatsSearch = '';
    this.showFilterMessage('Filters cleared successfully.');
  }


  clearFiltersheader(): void {
    this.sessionStatsStartDate = '';
    this.sessionStatsEndDate = '';
    this.appliedStartDate = '';
    this.appliedEndDate = '';
    //this.sessionStatsSearch = '';
    this.showFilterMessage('Filter cleared successfully.');
  }

  showFilterMessage(msg: string): void {
    this.sessionStatsFilterMessage = msg;
    if (this.filterMessageTimeout) {
      clearTimeout(this.filterMessageTimeout);
    }
    this.filterMessageTimeout = setTimeout(() => {
      this.sessionStatsFilterMessage = null;
      this.cdr.detectChanges();
    }, 3000);
  }

  private parseLocalDate(value: string): Date {
    if (!value) {
      return new Date(NaN);
    }

    // HTML date inputs produce YYYY-MM-DD; construct a local date instead of relying on Date parsing.
    const match = /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/.exec(value);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);
      return new Date(year, month, day);
    }

    return new Date(value);
  }

  get filteredGroupedSessionStats(): any[] {
    let filtered = this.groupedSessionStats;

    if (this.appliedStartDate) {
      const startDate = this.parseLocalDate(this.appliedStartDate);
      const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0).getTime();
      filtered = filtered.filter(stat => stat.timestamp >= start);
    }

    if (this.appliedEndDate) {
      const endDate = this.parseLocalDate(this.appliedEndDate);
      const end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999).getTime();
      filtered = filtered.filter(stat => stat.timestamp <= end);
    }

    // Default to showing only the last 7 consecutive dates if no date filters are applied
    if (!this.appliedStartDate && !this.appliedEndDate) {
      const today = new Date();
      const sevenDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6).getTime();
      filtered = filtered.filter(stat => stat.timestamp >= sevenDaysAgo);
    }

    if (this.sessionStatsSearch && this.sessionStatsSearch.trim() !== '') {
      const searchLower = this.sessionStatsSearch.toLowerCase().trim();
      filtered = filtered.filter(stat =>
        (stat.applications && stat.applications.toLowerCase().includes(searchLower)) ||
        (stat.ips && stat.ips.toLowerCase().includes(searchLower)) ||
        (stat.sessions && stat.sessions.some((s: any) =>
          (s.application_name && s.application_name.toLowerCase().includes(searchLower)) ||
          (s.local_ip_address && s.local_ip_address.toLowerCase().includes(searchLower)) ||
          (s.location_name && s.location_name.toLowerCase().includes(searchLower))
        ))
      );
    }
    return filtered;
  }

  get totalHistoricalSessions(): number {
    return this.groupedSessionStats.reduce((sum, stat) => sum + stat.total_sessions, 0);
  }

  get filteredHistoricalSessions(): number {
    return this.filteredGroupedSessionStats.reduce((sum, stat) => sum + stat.total_sessions, 0);
  }

  closeSessionStatsModal(): void {
    this.showSessionStatsModal = false;
    if (this.filterMessageTimeout) {
      clearTimeout(this.filterMessageTimeout);
    }
    this.sessionStatsFilterMessage = null;
  }

  getUserdetails() {
    this.totalUsersLoading = true;

    const columns = ["id", "name", "username", "recovery_email", "base_location", "status", "is_service_accounts", "is_blocked"];

    // Mimic the exact data-source fetching structure from UsersComponent
    Promise.all([
      this.usersService.GetUserGraph(columns),
      this.usersService.GetUserDetails()
    ]).then(([graphRes, detailsRes]) => {

      // Determine source based on storeManager state just like the management grid does
      let rawList = this.storeManager ? (detailsRes?.data || detailsRes) : (graphRes?.data || graphRes);

      if (rawList && Array.isArray(rawList)) {
        // Group ALL records by username to calculate rows identically
        const grouped = rawList.reduce((acc: any, current: any) => {
          const key = current.username;
          if (!acc[key]) {
            acc[key] = {
              ...current,
              all_locations: [current.base_location].filter(l => !!l)
            };
          } else {
            if (current.base_location && !acc[key].all_locations.includes(current.base_location)) {
              acc[key].all_locations.push(current.base_location);
            }
          }
          return acc;
        }, {});

        const allUniqueUsersList = Object.values(grouped);
        this.totalUsersCount = allUniqueUsersList.length.toString();
      } else {
        console.error('Unexpected response array format or data source empty.');
        this.totalUsersCount = '0';
      }
      this.totalUsersLoading = false;
      this.cdr.detectChanges();
    }).catch(error => {
      console.error('Error matching dashboard user details sequence:', error);
      this.totalUsersCount = '0';
      this.totalUsersLoading = false;
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  toggleVersionMenu(): void {
    // Note: Instead of jQuery $('#releaseVersionModal').modal('show');
    // Consider using an Angular boolean flag like `this.showVersionModal = true;` 
    // and bind it to your template or use a native Angular modal service (e.g., NgbModal / MatDialog).
  }

  getActiveUsers(isCache: boolean = false): void {
    // If caller requested cached data and we already have it, skip the network call
    if (isCache && this.activeUsers && this.activeUsers.length > 0) {
      this.isLoaded = true;
      return;
    }

    // Prevent duplicate concurrent requests
    if (this.activeUsersLoading) return;
    this.activeUsersLoading = true;
    this.isLoaded = false;
    this.cdr.detectChanges();

    this.usersService.GetActiveUsers(isCache, true)
      .then((response: any) => {
        let records = response.data;
        let users: { [key: string]: any[] } = {};
        if (!Array.isArray(records)) {
          console.error("Expected an array in response.data but got:", records);
          return;
        }
        records.forEach(item => {
          const createdDate = new Date(item.created_dt);
          const localDate = createdDate.toLocaleString('en-US', { timeZone: 'America/Chicago' });
          item.newDate = moment(localDate).format('LLL');

          if (!users[item.user_id]) {
            users[item.user_id] = [item];
          } else {
            users[item.user_id].push(item);
          }
        });

        let arr: any[] = [];
        Object.keys(users).forEach(userId => {
          arr.push({
            id: userId,
            name: users[userId][0].name,
            data: users[userId],
            data2: []
          });
        });

        arr.forEach(record => {
          let moduleIds: any[] = [];
          record.data.sort((a: any, b: any) => new Date(b.created_dt).getTime() - new Date(a.created_dt).getTime());

          record.data.forEach((record2: any) => {
            if (moduleIds.indexOf(record2.module_id) === -1) {
              moduleIds.push(record2.module_id);
              record.data2.push(record2);
            }
          });
          record.isBlocked = record.data[0].is_blocked;
        });

        this.ngZone.run(() => {
          this.activeUsers = arr;
          this.activeSessionsCount = arr.reduce((acc, curr) => acc + (curr.data2 ? curr.data2.length : 0), 0);
          this.loadBlockedUsers();
          this.cdr.detectChanges();
        });
      })
      .catch((error: any) => {
        console.error(error); // Replace with your logger
      })
      .finally(() => {
        this.ngZone.run(() => {
          this.isLoaded = true;
          this.activeUsersLoading = false;
          this.cdr.detectChanges();
        });
      });
  }

  get filteredActiveUsers(): any[] {
    let users = this.activeUsers;

    if (this.activeFilter === 'Online') {
      users = users.filter(u => u.isBlocked !== 3 && u.data2 && u.data2.length > 0);
    } else if (this.activeFilter === 'Offline') {
      users = users.filter(u => u.isBlocked !== 3 && (!u.data2 || u.data2.length === 0));
    } else if (this.activeFilter === 'Blocked') {
      users = users.filter(u => u.isBlocked === 3);
    }

    if (!this.search || this.search.trim() === '') {
      return users;
    }
    const searchLower = this.search.toLowerCase().trim();
    return users.filter(user =>
      (user.name && user.name.toLowerCase().includes(searchLower)) ||
      (user.id && user.id.toString().toLowerCase().includes(searchLower))
    );
  }

  setFilter(filterName: string): void {
    this.activeFilter = filterName;
  }

  openResetPasswordForm(): void {
    this.head = {};
    this.passwordHead = {};
    this.secondaryPasswordHead = {};
    this.resetSecondaryPassword = false;
    this.resetBtnText = 'Reset Secondary Password';
    this.showPassRstDetails = true;
    this.isUpdateSuccess = false;
    this.inputType = 'password';
    this.passwordHead.old_password = '';

    // Note: Use Angular ViewChild or ElementRef to focus instead of jQuery
    setTimeout(() => {
      document.getElementById('old_password')?.focus();
    }, 0);
  }


  closeResetPasswordForm(): void {
    this.showPassRstDetails = false;
  }

  hideShowPassword(): void {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }

  showPasswordPolicy(newPassword: string): void {
    this.isPasswordValid = true;
    if (newPassword) {
      if (this.passwordTerms.contain_upper_case === 1) {
        this.passwordValidationState.upperCase = /^(?=.*[A-Z]).+$/.test(newPassword);
        if (!this.passwordValidationState.upperCase) this.isPasswordValid = false;
      }

      if (this.passwordTerms.contain_lower_case === 1) {
        this.passwordValidationState.lowerCase = /^(?=.*[a-z]).+$/.test(newPassword);
        if (!this.passwordValidationState.lowerCase) this.isPasswordValid = false;
      }

      if (this.passwordTerms.contain_number === 1) {
        this.passwordValidationState.number = /.*[0-9].*/.test(newPassword);
        if (!this.passwordValidationState.number) this.isPasswordValid = false;
      }

      if (this.passwordTerms.contain_special_character === 1) {
        this.passwordValidationState.specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(newPassword);
        if (!this.passwordValidationState.specialChar) this.isPasswordValid = false;
      }

      if (this.passwordTerms.minimum_length) {
        this.passwordValidationState.minLength = String(newPassword).length >= this.passwordTerms.minimum_length;
        if (!this.passwordValidationState.minLength) this.isPasswordValid = false;
      }
    }
  }

  onToggleResetPassword(): void {
    this.resetSecondaryPassword = !this.resetSecondaryPassword;
    this.resetBtnText = this.resetSecondaryPassword ? 'Reset Password' : 'Reset Secondary Password';
    this.showTerms = false;
    this.head = {};
    this.passwordHead = {};
    this.secondaryPasswordHead = {};
  }


  passwordReset(): void {
    let details: any = {};

    if (!this.resetSecondaryPassword) {
      this.head = JSON.parse(JSON.stringify(this.passwordHead));
      details.is_primary = 1;
    } else {
      this.head = JSON.parse(JSON.stringify(this.secondaryPasswordHead));
      details.is_primary = 0;
    }

    this.isBtnEnabled = false;
    this.panelErrorMessage = null;
    const samePassword = this.checkPassword();

    if (samePassword) {
      details.id = this.common.SessionMemory.API.Get('user.id');
      details.current_password = this.head.old_password;
      details.new_password = this.head.new_password;

      this.authService.API.ResetPassword(details)
        .then(() => {
          this.isBtnEnabled = true;
          this.isUpdateSuccess = true;
          this.cdr.detectChanges();
        })
        .catch((error: any) => {
          this.isBtnEnabled = true;
          this.panelErrorMessage = error.error.error.error || 'Please try another password!';
          this.updateBtnError = true;
          this.updateBtnText = 'Oops!!. Something went wrong';
          this.cdr.detectChanges();

          setTimeout(() => {
            this.panelErrorMessage = null;
            this.updateBtnText = 'Update';
            this.updateBtnError = false;
            this.cdr.detectChanges();
          }, 2500);
        });
    } else {
      this.isBtnEnabled = true;
      this.updateBtnError = true;
      this.updateBtnText = 'Oops!!. Something went wrong';
      this.cdr.detectChanges();


      setTimeout(() => {
        this.panelErrorMessage = null;
        this.updateBtnText = 'Update';
        this.updateBtnError = false;
        this.cdr.detectChanges();
      }, 2500);
    }
  }

  checkPassword(): boolean {
    if (this.head.new_password && this.head.retype_password && this.head.new_password !== this.head.retype_password) {
      this.panelErrorMessage = 'New password and retype password must be same';
      return false;
    } else if (this.head.new_password && this.head.old_password && this.head.new_password === this.head.old_password) {
      this.panelErrorMessage = 'New password and current password can not be same';
      return false;
    }
    return true;
  }

  disableMFA(): void {
    this.mfaService.API.RefreshMFA()
      .then((response: any) => {
        this.message = response.data.message;
      })
      .catch((error: any) => {
        this.error = error.message;
      });
  }

  expandSecurityMFA(): void {
    this.isMFAExpanded = !this.isMFAExpanded;
  }

  expandSecurityResetPassword(): void {
    this.isResetPasswordExpanded = !this.isResetPasswordExpanded;
  }

  expandSecurityPrimeUsers(): void {
    this.isSecurityPrimeUsersExpanded = !this.isSecurityPrimeUsersExpanded;
  }

  expandPasswordPolicy(): void {
    this.isSecurityPasswordPolicyExpanded = !this.isSecurityPasswordPolicyExpanded;
  }

  isVerified(): void {
    this.usersService.GetUserById()
      .then((response: any) => {
        this.isMfaVerified = response.is_mfa_verified === 1;
      })
      .catch((error: any) => console.error(error));
  }

  getPasswordPolicy(): void {
    this.settingsService.GetPasswordPolicy()
      .then((response: any) => {
        this.passwordTerms = response.data[0];
        if (
          this.passwordTerms.contain_upper_case === 1 ||
          this.passwordTerms.contain_lower_case === 1 ||
          this.passwordTerms.contain_number === 1 ||
          this.passwordTerms.contain_special_character === 1 ||
          this.passwordTerms.minimum_length > 0
        ) {
          this.hasTerms = true;
        }
      })
      .catch((error: any) => console.error(error));
  }

  loadBlockedUsers(): void {
    const columns = ['id', 'name', 'username', 'recovery_email', 'base_location', 'status', 'is_service_accounts', 'is_blocked'];
    const field = ['is_blocked'];
    const value = [3];

    this.usersService.GetBlockedUserGraph(columns, field, value)
      .then((response: any) => {
        const resData = response;
        let arr: any[] = [];
        if (resData && resData.length > 0) {
          resData.forEach((item: any) => {
            arr.push({
              id: item.id,
              data2: [],
              isBlocked: item.is_blocked,
              name: item.name
            });
          });
          const ids = this.activeUsers.map(rec => Number(rec.id));
          arr.forEach(rec => {
            if (ids.indexOf(rec.id) === -1) {
              this.activeUsers.push(rec);
              this.cdr.detectChanges();
            }
          });
        }
      })
      .catch((error: any) => console.error(error));
  }

  checkCookieConsent(): void {
    this.cookiesAllowed = this.common.LocalMemory.API.Get('cookiesAllowed');
    const hasConsentDecision = (this.cookiesAllowed === 'accepted' || this.cookiesAllowed === 'declined');
    this.showCookieConsentPopup = !hasConsentDecision;
    if (hasConsentDecision) {
      this.showCookieConsentPopup = false;
    } else {
      this.findByCopyright();
    }
  }

  checkCookieConsentInitial(): void {
    if (this.cookiesAllowed === 'accepted' || this.cookiesAllowed === 'declined') {
      this.showCookieConsentPopup = false;
    } else {
      this.showCookieConsentPopup = true;
    }
  }

  logoutAndRedirect(): void {
    // Attempt to store and clear cache, but always proceed to logout redirect even on errors.
    this.storeCacheMetadata()
      .then(() => this.clearCache())
      .catch(err => {
        console.warn('Warning during cache store/clear before logout:', err);
      })
      .finally(() => {
        // Try invoking server logout; ignore failures and proceed to redirect.
        this.loginService.API.Logout()
          .catch((err: any) => {
            console.warn('Logout API returned error, proceeding to client-side redirect:', err);
          })
          .finally(() => {
            const userSession = this.common.SessionMemory.API.Get('user.session');
            const moduleId = this.moduleService.id;

            // Notify other tabs before clearing local session
            if (userSession) {
              try {
                localStorage.setItem(`scout_logout_type_${userSession}`, 'manual');
                localStorage.setItem(`scout_logout_event_${userSession}`, Date.now().toString());
                localStorage.removeItem(`scout_last_activity_${userSession}`);

                const cleanup = () => {
                  localStorage.removeItem(`scout_logout_event_${userSession}`);
                  localStorage.removeItem(`scout_logout_type_${userSession}`);
                };
                setTimeout(cleanup, 1500);
                window.addEventListener('pagehide', cleanup, { once: true });
              } catch { }
            }

            // Clear client-side session and cookies to ensure the app is logged out locally
            try {
              this.common.SessionMemory.API.Clear();
            } catch (err) {
              console.warn('Failed to clear session memory:', err);
            }
            try {
              this.clearCookies();
            } catch (err) {
              console.warn('Failed to clear cookies during logout:', err);
            }

            if (userSession && moduleId) {
              this.loginService.API.RemoveSessionId(userSession, moduleId.toString()).finally(() => {
                this.redirectToLoginWithReload();
                this.closeSuccessPopup();
              });
            } else {
              this.redirectToLoginWithReload();
              this.closeSuccessPopup();
            }

            if (typeof Worker !== 'undefined') {
              const worker = new Worker('application/utility/cache-worker.js');
              worker.postMessage({ action: 'clearCache', domain: window.location.hostname });
              worker.onmessage = (event) => {
                if (event.data.success) {
                  this.closeSuccessPopup();
                  this.updateAppVersionAfterReload();
                } else {
                  console.error('Error clearing cache metadata:', event.data.message);
                }
                worker.terminate();
              };
              worker.onerror = (error) => {
                console.error('Worker error during cache clear:', error.message);
                worker.terminate();
              };
            }
          });
      });
  }

  redirectToLoginWithReload(): void {
    this.router.navigate(['/login']);
  }

  updateAppVersionAfterReload(): void {
    try {
      const copyrightDetails = this.common.SessionMemory.API.Get('copyrightDetails');
      if (copyrightDetails) {
        const parsedDetails = JSON.parse(copyrightDetails);
        this.latestVersion = parsedDetails.app_version || 'unknown';
      }
    } catch (error) {
      console.error('Error updating app version:', error);
    }
  }

  storeCacheMetadata(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        const version = new Date().getTime();
        const cacheKeys = [
          `./?v=${version}`,
          `./index.html?v=${version}`,
          `./main.css?v=${version}`,
          `./404.html?v=${version}`,
          `./404.png?v=${version}`,
          `./main.js?v=${version}`,
          '/api/user/profile',
          '/api/user/settings',
        ];

        if (typeof Worker !== 'undefined') {
          const worker = new Worker('application/utility/cache-worker.js');
          const domain = window.location.hostname;
          worker.postMessage({ action: 'storeCache', domain, data: cacheKeys });

          worker.onmessage = (event) => {
            if (event.data.success) {
              this.showCookieConsentPopup = false;
              resolve();
            } else {
              reject(new Error(event.data.message));
            }
            worker.terminate();
          };
          worker.onerror = (error) => {
            reject(new Error('Worker error: ' + error.message));
            worker.terminate();
          };
        } else {
          reject(new Error('Web Workers are not supported in this browser.'));
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  clearDomainCache(): Promise<void> {
    const domain = window.location.hostname;
    if (typeof Worker !== 'undefined') {
      const worker = new Worker('application/utility/cache-worker.js');
      return new Promise((resolve, reject) => {
        worker.postMessage({ action: 'clearCache', domain });
        worker.onmessage = (event) => {
          if (event.data.success) {
            resolve();
          } else {
            reject(new Error(event.data.message));
          }
          worker.terminate();
        };
        worker.onerror = (error) => {
          reject(new Error('Worker error: ' + error.message));
          worker.terminate();
        };
      });
    } else {
      return Promise.reject(new Error('Web Workers are not supported in this browser.'));
    }
  }

  setCookie(name: string, value: string, days: number, domain: string, path?: string): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const currentDate = new Date();
    currentDate.setTime(currentDate.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${currentDate.toUTCString()}`;
    const specificPath = path || `/${window.location.pathname.split('/')[1]}`;
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=${specificPath}; domain=${domain || window.location.hostname}; Secure; SameSite=Strict`;
  }

  getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  getUserConsent(): boolean {
    try {
      const consent = this.getCookie('cookiesAllowed');
      return consent === 'true';
    } catch (error) {
      console.error('Error checking cookie consent:', error);
      return false;
    }
  }

  saveCookies(): void {
    this.storeCacheMetadata();
    this.latestVersion = this.copyrightDetails?.app_version;
    try {
      this.common.LocalMemory.API.Post('cookiesAllowed', 'accepted');
      const userInfo = {
        session: this.common.SessionMemory.API.Get('user.session') || '',
        token: this.common.SessionMemory.API.Get('user.token') || '',
        user_id: this.common.SessionMemory.API.Get('user.user_id') || '',
        username: this.common.SessionMemory.API.Get('user.username') || ''
      };

      const specificPath = `/${window.location.pathname.split('/')[1]}`;
      this.setCookie('userInfo', JSON.stringify(userInfo), 15, window.location.hostname, specificPath);
      this.showCookieConsentPopup = false;
    } catch (error) {
      console.error('Error saving user information as cookie:', error);
    }
  }

  acceptCookies(): void {
    this.common.LocalMemory.API.Post('cookiesAllowed', 'accepted');
    this.cookiesAllowed = 'accepted';
    this.showCookieConsentPopup = false;

    const specificPath = `/${window.location.pathname.split('/')[1]}`;
    this.setCookie('cookiesAllowed', 'true', 15, window.location.hostname, specificPath);
    this.saveCookies();
  }

  declineCookies(): void {
    this.common.LocalMemory.API.Post('cookiesAllowed', 'declined');
    this.cookiesAllowed = 'declined';
    this.showCookieConsentPopup = false;
  }

  clearCookies(): void {
    const currentDate = new Date();
    currentDate.setTime(currentDate.getTime() - 1);
    const expires = `expires=${currentDate.toUTCString()}`;
    const currentDomain = window.location.hostname;
    const specificPath = `/${window.location.pathname.split('/')[1]}`;

    document.cookie.split(';').forEach(cookie => {
      const cookieName = cookie.split('=')[0].trim();
      document.cookie = `${cookieName}=; ${expires}; path=${specificPath}; domain=${currentDomain}`;
    });
  }

  async clearCache(): Promise<void> {
    try {
      await this.clearDomainCache();
      this.clearCookies();
      setTimeout(() => {
        this.showSuccessCachePopup = true;
      }, 0);
    } catch (error) {
      console.error('Error clearing cache:', error);
    } finally {
      // Close the cache popup after a short delay but do NOT trigger logout here.
      // logoutAndRedirect should control the overall logout flow to avoid recursion.
      setTimeout(() => {
        this.closeCachePopup();
      }, 1000);
    }
  }

  getPlatform(): any {
    let platform = 'Unknown';
    let shortcut = 'Ctrl + Shift + R';
    let ipads = '';

    if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent;

      if (/iPad/.test(ua) || (/Macintosh/.test(ua) && 'ontouchend' in document)) {
        platform = 'iPad';
        shortcut = " please navigate to Chrome's three-dot menu in the top right corner, select 'History' from the dropdown, set the duration to 'All time,' check the boxes for 'Cookies and cache,' and then click 'Clear browsing data'";
        ipads = 'To ensure these updates are fully loaded,';
      } else if (/Macintosh/.test(ua)) {
        platform = 'Mac';
        shortcut = 'Cmd + Shift + R';
        ipads = 'Please press ';
      } else if (/Windows/.test(ua)) {
        platform = 'Windows';
        shortcut = 'Ctrl + Shift + R';
        ipads = 'Please press ';
      }
    }

    return { platform, shortcut, ipads };
  }

  findByCopyright(): void {
    // Prevent duplicate/concurrent calls
    if (this.copyrightLoading) return;
    if (this.copyrightDetails) return;

    this.showCookieConsentPopup = false;
    const platformInfo = this.getPlatform();
    this.deviceThatUses = platformInfo.shortcut;
    this.ipadContent = platformInfo.ipads;

    this.copyrightLoading = true;
    this.authService.API.FindByCopyright()
      .then((response: any[]) => {
        this.copyrightDetails = response.find(x => x.module_id === this.moduleService.id);
        sessionStorage.setItem('copyrightDetails', JSON.stringify(this.copyrightDetails));
        this.newVersion = this.copyrightDetails?.app_version;

        const consent = this.getUserConsent();
        if (!consent && this.cookiesAllowed !== 'declined') {
          this.showCookieConsentPopup = true;
        } else {
          this.showCookieConsentPopup = false;
        }

        if (this.newVersion !== this.currentVersion || !consent) {
          this.showCookieConsentPopup = true;
        }

        if (consent) {
          this.latestVersion = this.copyrightDetails?.app_version;
        }
        this.closeSuccessPopup();
      })
      .catch((error: any) => console.error(error))
      .finally(() => {
        this.copyrightLoading = false;
      });
  }

  closeCachePopup(): void {
    this.showCacheClearPopup = false;
  }

  closeSuccessPopup(): void {
    this.showSuccessCachePopup = false;
  }

  resetAtMidnight(): void {
    if (typeof window === 'undefined') return;
    const now = new Date();
    const night = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 1, 30, 0);
    const msToMidnight = night.getTime() - now.getTime();

    if (msToMidnight >= 0) {
      setTimeout(() => {
        window.location.href = window.location.href + '?eraseCache=true';
      }, msToMidnight);
    }

    const isFirstLoad = this.common.SessionMemory.API.Get('isFirstLoad');
    if (!isFirstLoad) {
      setTimeout(() => {
        this.common.SessionMemory.API.Post('isFirstLoad', 'true');
      }, 2500);
    }
  }

  checkPreviousCache(): void {
    if (this.cacheChecked) return;
    this.cacheChecked = true;

    if ('caches' in window) {
      const specificPath = `/${window.location.pathname.split('/')[1]}`;
      caches.keys().then(cacheNames => {
        let segmentFound = false;

        Promise.all(
          cacheNames.map(cacheName =>
            caches.open(cacheName).then(cache =>
              cache.keys().then(requests => {
                const urls = requests.map(r => r.url);
                const segments = urls.map(url => {
                  const match = url.match(/\.com\/([^/]+)/);
                  return match ? `/${match[1]}` : null;
                });

                if (segments.includes(specificPath)) {
                  segmentFound = true;
                }
              })
            )
          )
        ).then(() => {
          if (!segmentFound) {
            this.acceptCookies();
          }
        });
      });
    }
  }
}